import { ModelWithoutId } from 'app/type';

import { BrandAttributes } from './brand-attributes';

export type StoreAttributes = BrandAttributes;

export const createEmptyStoreAttribute = (): ModelWithoutId<StoreAttributes> => ({
    clientId: 0,
    name: '',
    value: 0,
    dateCreated: '',
    dateEdited: '',
});
